<trv-tabset (tabChanged)="tabChanged($event)" [activeTab]="selectedTabb">
  <trv-tab header="Dygnsgraf" id="day">
    <ng-template trvTabContent>
      <div class="container">
        <img #daygraph id="daygraph" [src]="dayurl">
      </div>
    </ng-template>
  </trv-tab>
  <trv-tab header="Veckograf" id='week'>
    <ng-template trvTabContent>
      <div class="container">
        <img #weekgraph id="weekgraph" [src]="weekurl">
      </div>
    </ng-template>
  </trv-tab>
  <trv-tab header="Månadsgraf" id=month>
    <ng-template trvTabContent>
      <div class="container">
        <img #monthgraph id="monthgraph" [src]="monthurl">
      </div>
    </ng-template>
  </trv-tab>
  <trv-tab header="Säsongsgraf" id=season>
    <ng-template trvTabContent>
      <div class="container">
        <img #seasongraph id="seasongraph" [src]="seasonurl">
      </div>
    </ng-template>
  </trv-tab>
  <trv-tab header="Stationslista" id="stations">
    <ng-template trvTabContent>
      <div class="container">
        <app-stationlist></app-stationlist>
      </div>
    </ng-template>
  </trv-tab>
  <trv-tab header="Information" id="Information">
    <ng-template trvTabContent>
      <div class="container">
        <app-information></app-information>
      </div>
    </ng-template>
  </trv-tab>
</trv-tabset>
